import { type EnticerSignal , EnticerSignalType } from './types';
import { Box , Text } from '../../../../mads';
import { Clock, People, Responsive, Star } from '../../../../mads/icons';

import { colors } from '@indeed/ifl-tokens';
import { StyleSheet } from 'react-native';

interface EnticerSignalsContainerProps {
    signals: EnticerSignal[];
}

const ICON_MAP: Record<EnticerSignalType, React.ComponentType<{ size: 'xs' | 'sm' | 'md' }>> = {
    [EnticerSignalType.RESPONSIVE_EMPLOYER]: Responsive,
    [EnticerSignalType.HIRED_SIGNAL]: People,
    [EnticerSignalType.TOP_RATED_EMPLOYER]: Star,
    [EnticerSignalType.EARLY_APPLICANT]: Clock,
};

export function EnticerSignalsContainer({ signals }: EnticerSignalsContainerProps) {
    if (signals.length === 0) {
        return null;
    }

    const borderRadius = signals.length === 1 ? 12 : 20;

    return (
        <Box
            sx={[styles.container, { borderRadius }]}
            accessible
            accessibilityLabel={signals.map((signal) => signal.text).join(', ')}
        >
            {signals.map((signal) => {
                const IconComponent = ICON_MAP[signal.type];
                return (
                    <Box key={signal.type} sx={styles.signalRow}>
                        <IconComponent size="xs" />
                        <Text sx={styles.signalText}>{signal.text}</Text>
                    </Box>
                );
            })}
        </Box>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: colors.expressive.gray.weak,
        paddingHorizontal: 12,
        paddingVertical: 8,
        marginTop: 8,
    },
    signalRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        paddingVertical: 2,
    },
    signalText: {
        fontSize: 13,
        lineHeight: 18,
    },
});
